export default __webpack_public_path__ + "static/media/bus.f8cca74d.jpeg";